import { Row } from "react-bootstrap";
import FormField from "../../components/common/FormField";
const fields = [
  ["calle", "Calle", 6, 100],
  ["num_exterior", "No. exterior", 3, 50],
  ["num_interior", "No. interior", 3, 50],
  ["colonia", "Colonia", 6, 100],
  ["codigo_postal", "Código postal", 3, 10],
  ["localidad", "Localidad", 3, 100],
  ["municipio", "Municipio", 4, 100],
  ["estado", "Estado", 4, 100],
  ["pais", "País", 4, 100],
  ["referencia", "Referencia", 6, 100],
  ["telefono", "Teléfono", 3, 30],
  ["telefono2", "Teléfono 2", 3, 30],
];
export default function AddressFields({
  value,
  onChange,
  errors = {},
  disabled = false,
  required = false,
}) {
  return (
    <Row className="g-3">
      {fields.map(([name, label, md, maxLength]) => (
        <FormField
          key={name}
          {...{ name, label, md, maxLength, onChange, disabled }}
          value={value?.[name]}
          error={errors[name]}
          required={
            required &&
            [
              "calle",
              "num_exterior",
              "colonia",
              "municipio",
              "estado",
              "pais",
            ].includes(name)
          }
        />
      ))}
    </Row>
  );
}
